import { render } from "./BigPreview.vue?vue&type=template&id=2563e471&scoped=true"
import script from "./BigPreview.vue?vue&type=script&lang=js"
export * from "./BigPreview.vue?vue&type=script&lang=js"

import "./BigPreview.vue?vue&type=style&index=0&id=2563e471&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2563e471"]])

export default __exports__